// extracted by mini-css-extract-plugin
export default {"root":"root___PTX8b","rel":"rel___CQbeq"};